import { render, staticRenderFns } from "./formGenerator.vue?vue&type=template&id=3b52145a&scoped=true&"
import script from "./formGenerator.vue?vue&type=script&lang=js&"
export * from "./formGenerator.vue?vue&type=script&lang=js&"
import style0 from "./formGenerator.vue?vue&type=style&index=0&id=3b52145a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b52145a",
  null
  
)

export default component.exports